import React, {useMemo} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import JobOpeningsOverview from "@widgets/jobOpenings/JobOpeningsOverview";

const JobOpenings = () => {
    const route: Route = useMemo(() => router.jobOpenings, []);

    return (
        <AdminLayout currentPage={route}>
            <JobOpeningsOverview route={route}/>
        </AdminLayout>
    );
};

export default JobOpenings;